import { useQuery } from '@tanstack/react-query'

import api from '@/services/api'

type SessionPermissions = {
  role?: string | null
  is_super_admin?: boolean | null
  permissions?: Record<string, string[]>
}

/**
 * Whether to offer "Import deal book": an admin (the book places deals past
 * Triage) whose effective permissions include pipeline create, the two checks
 * POST /deal-book-import makes. Read from GET /auth/permissions, which answers
 * for a local and an Entra SSO session alike; the API stays the authority.
 */
export function canImportDealBook(session: SessionPermissions | null | undefined): boolean {
  if (!session) return false
  if (session.is_super_admin) return true
  const role = String(session.role ?? '').toLowerCase()
  if (role !== 'admin' && role !== 'super_admin') return false
  const actions = session.permissions?.pipeline
  return Boolean(actions?.includes('create'))
}

export function useCanImportDealBook(): boolean {
  const session = useQuery({
    queryKey: ['auth', 'permissions'],
    queryFn: async () => {
      const { data } = await api.get<SessionPermissions>('/auth/permissions')
      return data
    },
    staleTime: 30_000,
    retry: false,
  })
  return canImportDealBook(session.data)
}
